export const useAppCache = () => {
  const { locale } = useI18n()
  const route = useRoute()

  // The same normalization the widgets use for the lookup
  const path = computed(() => {
    const current = route.path.startsWith('/') ? route.path.slice(1) : route.path
    return current.startsWith('ky/') ? current.substring(3) : current
  })

  // Only the entries of the current page: the full map of the site's SEO texts
  // (~340 KB) used to be serialized into the payload of every page (#296)
  return useFetch('/api/data', {
    key: () => `app-cache-${locale.value}-${path.value}`,
    server: true,
    default: () => ({ data: { data: {} } }),
    dedupe: 'defer',
    query: {
      lang: locale,
      path
    }
  })
}
